import PropTypes from 'prop-types';
import React from 'react';

import { PageContext } from '../../../contexts/ContextCreator';
import ModalAbstraction from '../../CallToAction/LeftRailCTA/ModalAbstraction/ModalAbstraction';
import JobSearchFilter from '../../JobV3/JobSearchFilter/JobSearchFilter';

import './JobFiltersModal.scss';

export default class JobFiltersModal extends React.PureComponent {
    constructor(props) {
        super();
        this.state = {
            showModal: false,
        };
    }

    static contextType = PageContext;

    open = () => {
        const { setModalActive } = this.context;
        this.setState({ showModal: true }, () => setModalActive(true));
    };

    close = () => {
        const { setModalActive } = this.context;
        this.setState({ showModal: false }, () => setModalActive(false));
    };

    static propTypes = {
        /**
         * Button to be rendered to trigger modal actions
         */
        renderButton: PropTypes.func,
    };

    static defaultProps = {
        renderButton: () => {},
    };

    render() {
        return (
            <div className="component-Modals-JobFiltersModal">
                {this.props.renderButton({ onClick: this.open })}

                <ModalAbstraction
                    showModal={this.state.showModal}
                    onClose={this.close}
                    showButton={false}
                >
                    <JobSearchFilter modalMode={true} onClick={this.close} />
                </ModalAbstraction>
            </div>
        );
    }
}
